<template>
  <div class="ma-6">
    <v-dialog width="500" v-model="dialog">
        <PostEditor/>
    </v-dialog>
    <v-container>
      <v-container>
        <v-row justify="center">
          <div style="width: 600px" class="elevation-1">
            <div class="ma-2">
              <v-text-field @click="setdialog(true)"   dense readonly label="Bagikan informasi" rounded filled></v-text-field>
            </div>
          </div>
        </v-row>
      </v-container>
      <div class="mt-6">
        <v-container>
          <v-row dense>
            <v-col v-for="(item, i) in posts" :key="i" cols="12">
              <Post :post="item"/>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-container>
  </div>
</template>

<script>
import Post from '@/components/sosial/Post'
import moment from 'moment'
import PostEditor from '@/components/sosial/PostEditor'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'NewsFeed',
  components: { PostEditor, Post },
  data: () => ({
    tab: null,
    posts: [
      {
        postid: 1122,
        waktu: moment().add(0, 'hours').toISOString(),
        member: {
          id: 1,
          name: 'QPAY',
          avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1523888116/avianah2h.jpg'
        },
        msg: 'Voucher Indosat DATA Unlimited\n' +
            '------------\n' +
            '🔥VID1 >> Voucher Unlimited Apk + 1GB 30HR >> 23.900\n' +
            '🔥VID2 >> Voucher Unlimited Apk + 2GB 30HR >> 38.100\n' +
            '🔥VID3 >> Unlimited APK + YT + SMS Sesama + 3 GB 30 Hr >> 57.100\n' +
            '🔥VID7 >> Unlimited APK + YT&IG + SMS Sesama + 7GB 30Hr >> 75.800\n' +
            '🔥VID10 >> Unlimited APK + YT&IG + SMS&Telp Sesama+10GB >> 30Hr  \n' +
            '94.450\n' +
            '🔥VID20 >> UNLIMITED KUOTA + APK + SMS&Telp all 30 Hr >> 143.800',
        totallike: 0,
        totalcomment: 0,
        comment: []
      },
      {
        member: {
          id: 1,
          name: 'Pulsapro',
          avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1572776387/pulsa-pro-login-fb5dbea9c25bde7.png'
        },
        msg: '<b>INFO 19-2-2021</b><br/>' +
            'Turun Harga Paket K048 S5(1500)-S10(4500)-S20(1250)-SI500M(300)= 80.450.000 hanya sampai jam 21:00.Setelah jam 21 kembali harga 84.950.000.\n' +
            'Segera kirim transaksi.',
        totallike: 0,
        totalcomment: 0,
        comment: []
      },
      {
        postid: 1122,
        waktu: moment().add(0, 'hours').toISOString(),
        member: {
          id: 1,
          name: 'QPAY',
          avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1523888116/avianah2h.jpg'
        },
        msg: 'Voucher Indosat DATA Unlimited\n' +
            '------------\n' +
            '🔥VID1 >> Voucher Unlimited Apk + 1GB 30HR >> 23.900\n' +
            '🔥VID2 >> Voucher Unlimited Apk + 2GB 30HR >> 38.100\n' +
            '🔥VID3 >> Unlimited APK + YT + SMS Sesama + 3 GB 30 Hr >> 57.100\n' +
            '🔥VID7 >> Unlimited APK + YT&IG + SMS Sesama + 7GB 30Hr >> 75.800\n' +
            '🔥VID10 >> Unlimited APK + YT&IG + SMS&Telp Sesama+10GB >> 30Hr  \n' +
            '94.450\n' +
            '🔥VID20 >> UNLIMITED KUOTA + APK + SMS&Telp all 30 Hr >> 143.800',
        totallike: 0,
        totalcomment: 0,
        comment: []
      },
      {
        member: {
          id: 1,
          name: 'Pulsapro',
          avatar: 'https://res.cloudinary.com/dd5jfnv3x/image/upload/v1572776387/pulsa-pro-login-fb5dbea9c25bde7.png'
        },
        msg: '<b>INFO 19-2-2021</b><br/>' +
            'Turun Harga Paket K048 S5(1500)-S10(4500)-S20(1250)-SI500M(300)= 80.450.000 hanya sampai jam 21:00.Setelah jam 21 kembali harga 84.950.000.\n' +
            'Segera kirim transaksi.',
        totallike: 0,
        totalcomment: 0,
        comment: []
      }
    ]
  }),
  computed: {
    ...mapState('FeedStore', ['dialog'])
  },
  methods: {
    ...mapActions('FeedStore', ['setdialog'])
  }
}
</script>

<style scoped>

</style>
